export default __webpack_public_path__ + "static/media/cybertestW.c8bf934e.png";